<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="奖品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'prizesName',
              {
                rules: [
                  { required: true, message: '请输入奖品名称(限制15个字)' },
                ],
              },
            ]"
            placeholder="请输入奖品名称"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="奖品类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            :disabled="canChangePrizeType"
            @change="fieldValue"
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请选择奖品类型' }] },
            ]"
            :triggerChange="true"
            placeholder="请选择奖品类型"
            dictCode="prize_type"
          />
        </a-form-item>
        <a-form-item
          label="奖品价值(元)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="prizeValue"
            v-decorator="[
              'prizeValue',
              { rules: [{ required: true, message: '请输入奖品奖品价值' }] },
            ]"
            placeholder="请输入奖品价值"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="奖品图片"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['prizesImage']"
          />
        </a-form-item>
        <!--<a-form-item v-if="prizeNumShow" label="奖品总数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="true" v-decorator="['quantity']"></a-input>
        </a-form-item>
        <a-form-item v-if="prizeNumShow" label="奖品剩余数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="true" v-decorator="['remainNum']"></a-input>
        </a-form-item>-->
        <a-form-item
          v-if="prizeNumShow"
          :label="labelValue"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="addPrizeNum"
            v-decorator="[
              'addPrizeNum',
              {
                rules: [{ required: true, message: '请输入奖品数量(正整数)' }],
              },
            ]"
            :placeholder="labelValue"
            type="test"
          ></a-input>
        </a-form-item>

        <a-form-item
          v-if="activityIdShow"
          label="红包活动ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            v-decorator="[
              'activityId',
              { rules: [{ required: true, message: '请输入红包活动ID' }] },
            ]"
            placeholder="请输入红包活动ID"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="activityIdShow"
          label="奖品有效期(天)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="prizeInDate"
            v-decorator="['prizeInDate']"
            placeholder="请输入有效期(天)，从获得奖品计时"
          ></a-input>
        </a-form-item>

        <!-- <a-form-item label="是否消耗积分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="[ 'integralFlag',{ rules: [{ required: true, message: '请选择是否消耗积分' }] }]" placeholder="请选择是否消耗积分" @change="isShowIntegral">
            <a-select-option v-if="integralFlagList != null" v-for="(item, index) in integralFlagList" :value="item.value" :key="index">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item
          label="是否消耗积分"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="integralFlag"
            @change="changeIsIntegral"
          />
        </a-form-item>
        <a-form-item
          v-if="isIntegral"
          label="奖品消耗积分数值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="integral"
            v-decorator="[
              'integral',
              {
                rules: [
                  { required: true, message: '请输入奖品消耗积分数值(正整数)' },
                ],
              },
            ]"
            placeholder="请输入奖品消耗积分数值"
            type="number"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="isIntegral"
          label="奖品折扣积分数值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="discountIntegral"
            v-decorator="['discountIntegral']"
            placeholder="请输入奖品折扣积分数值"
            type="number"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="奖品启用状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'usedStatus',
              { rules: [{ required: true, message: '请选择奖品启用状态' }] },
            ]"
            :triggerChange="true"
            dictCode="obj_status"
          />
        </a-form-item>
        <!--<a-form-item label="奖品关联活动" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag  v-decorator="['activityType', { rules: [{ required: true, message: '请选择奖品关联活动' }] }]" :triggerChange="true" dictCode="association_activity"/>
        </a-form-item>-->
        <a-form-item
          label="奖品日消耗限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="dayExchangeLimit"
            v-decorator="['dayExchangeLimit']"
            placeholder="请输入奖品日兑换限制"
            type="number"
          ></a-input>
        </a-form-item>
        <!-- <a-form-item
          label="用户每人天领取限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="personDayLimit"
            v-decorator="['personDayLimit']"
            placeholder="请输入每人天领取限制"
            type="number"
          ></a-input>
        </a-form-item> -->
        <!-- <a-form-item
          label="奖品周领取频率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="fieldValue"
            v-decorator="['prizeWeekFrequency']"
            :triggerChange="true"
            placeholder="请选择奖品周领取频率"
            dictCode="prize_week_frequency"
          />
        </a-form-item> -->
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            min="0"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="sortIndex"
            v-decorator="['sortIndex']"
            placeholder="排序数字越小越靠前"
            type="number"
          ></a-input>
        </a-form-item>
        <!--<a-form-item label="奖品介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea type="text" max-length="100" v-decorator="['content']" rows="4" placeholder="请输入奖品介绍，限制100个字"/>
        </a-form-item>
        <a-form-item label="奖品兑换说明" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea max-length="120" v-decorator="['exchangeNote']" rows="4" placeholder="请输入奖品兑换说明，限制120个字"/>
        </a-form-item>-->
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
// import JImageUpload from '@/components/jeecg/JImageUpload';
// import moment from 'moment';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'IntegralModal',
  components: {
    JDate,
    // JImageUpload,
    UploadImage,
  },
  props: {},
  data() {
    return {
      fileList: '',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      disableSubmit: false,
      activityIdShow: false,
      canChangePrizeType: false,
      prizeNumShow: false,
      labelValue: '',
      integralFlagList: [
        {
          name: '是',
          value: '1',
        },
        {
          name: '否',
          value: '0',
        },
      ],
      model: {},
      isIntegral: false, //是否消耗积分开关
      integralFlag: false, // 默认消耗积分选中
      isIntegralFlag: 0,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/market/prize/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/market/prize/edit',
      },
    };
  },
  created() {},
  /*watch: {
      model(newVal, oldVal) {
        this.reloadDataSource()
      }
    },*/
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      if (record.id) {
        if (record.type === 1) {
          this.prizeNumShow = true;
          this.activityIdShow = false;
        } else if (record.type === 3) {
          this.prizeNumShow = false;
          this.activityIdShow = true;
        } else if (record.type === 2) {
          this.prizeNumShow = false;
          this.activityIdShow = false;
        }
        this.labelValue = '奖品追加数量';
      } else {
        this.canChangePrizeType = false;
        this.activityIdShow = false;
        this.prizeNumShow = false;
        this.labelValue = '奖品初始数量';
      }
      console.log(record);
      this.fileList = record.prizesImage;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          prizesImage: record.prizesImage
            ? process.env.VUE_APP_FILE_PATH + record.prizesImage
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'prizesName',
            // 'prizeWeekFrequency',
            'activityId',
            'prizeInDate',
            // 'personDayLimit',
            'prizeValue',
            'addPrizeNum',
            'type',
            // 'prizesImage',
            'content',
            'exchangeNote',
            'quantity',
            'remainNum',
            'integral',
            'usedStatus',
            'activityType',
            'dayExchangeLimit',
            'integralFlag',
            'sortIndex',
            'discountIntegral'
          )
        );
      });
      if (this.model.integralFlag === 1) {
        this.integralFlag = true;
        this.isIntegral = true;
        this.prizeNumShow = true;
      } else {
        this.integralFlag = false;
        this.isIntegral = false;
      }

      this.fieldValue(this.model.type);
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          formData.integralFlag = this.isIntegralFlag;
          formData.prizesImage = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'prizesName',
          'activityId',
          // 'prizeWeekFrequency',
          'prizeInDate',
          'prizeValue',
          // 'personDayLimit',
          'addPrizeNum',
          'type',
          'prizesImage',
          'content',
          'exchangeNote',
          'quantity',
          'remainNum',
          'integral',
          'usedStatus',
          'activityType',
          'dayExchangeLimit',
          'integralFlag',
          'sortIndex',
          'discountIntegral'
        )
      );
    },

    changeIsIntegral(checked) {
      if (checked) {
        this.isIntegralFlag = 1;
      } else {
        this.isIntegralFlag = 0;
      }
      this.integralFlag = checked;
      this.isIntegral = checked;
    },

    fieldValue(e) {
      if (e === '2') {
        //电子卡券
        this.activityIdShow = false;
        this.prizeNumShow = false; //不展示数量
      } else if (e === '1') {
        //实体
        this.activityIdShow = false;
        this.prizeNumShow = true; //展示数量
      } else if (e === '3') {
        //红包
        this.activityIdShow = true;
        this.prizeNumShow = true; //展示数量
      }
    },

    deal() {
      var $this = $(this),
        _val = $this.val();
      if (_val.length > 20) {
        $this.val(_val.substring(0, 20));
      }
    },

    isShowIntegral(e) {
      if (e === '1') {
        //消耗积分
        this.isIntegral = true;
      } else {
        this.isIntegral = false;
      }
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        prizesImage: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
